/* 
Object:         Google Maps
Description:    Handler for Google Maps using the token in the appsettings configuration
Used in:        Modules where Google Maps is beging used.
*/


// Installeer eerst npm package: @googlemaps/js-api-loader
// Importeer de loader waarmee we google maps API kunnen laden
import { Loader } from "@googlemaps/js-api-loader";

// Maak een nieuwe loader met onze API key, de loader kan verder geconfigureerd worden
const loader = new Loader({
    apiKey: "AIzaSyAwFjHZDiAxWFhijlvJ8qH-tea7zLptKLo"
});

// Opmerking: Gebruik van google api objecten pas gebeuren nadat de api geladen is.

// Promise zonder destructuring
let mapsApi: google.maps.MapsLibrary;

loader.importLibrary("maps")
    .then((library) => {
        mapsApi = library;
    })
    .catch(e => {
        console.error("Error loading Google Maps library: ", e);
    });

loader.importLibrary("marker")
    .then((markerLib) => {
        // markerLib.AdvancedMarkerElement is nu beschikbaar
        const marker = new markerLib.AdvancedMarkerElement({
            position: { lat: 51.813, lng: 5.244 },
            map: map
        });
    })
    .catch(e => {
        console.error("Error loading Marker library: ", e);
    });


//Googlemap reference
let map: google.maps.Map;
let nawMarker: any;

function ToCoordinateNumber(coordinateString: string): number {
    const result = Number(coordinateString.replace(',', '.'));
    return result;
}

/**
* place markers and navigate to / pan to ..
* @param {any} latLng
* @param {any} map
*/
export function placeMarkerAndPanTo(latLng: google.maps.LatLng, map: any, latitudeFieldId?: string, longitudeFieldId?: string): void {
    if (nawMarker !== undefined) {
        nawMarker.map = null;
    }

    nawMarker = new google.maps.marker.AdvancedMarkerElement({
        position: latLng,
        map: map
    });

    map.panTo(latLng);

    //update position
    if (latitudeFieldId !== undefined || longitudeFieldId !== undefined) {
        const latitude: JQuery<HTMLElement> = $(latitudeFieldId);
        const longitude: JQuery<HTMLElement> = $(longitudeFieldId);
        latitude.val(latLng.lat().toFixed(6));
        longitude.val(latLng.lng().toFixed(6));
    }
}

/**
 * init google maps
 * @param {string} divid
 * @param {string} input_latitude_string
 * @param {string} input_longitude_string
 * @param {boolean} editmode
 * @param {integer} mapsZoom
 */
export function initialize(divid: string, input_latitude_string: string, input_longitude_string: string, editmode: boolean, mapsZoom: number): void {
    // The location of the center
    const latitude = ToCoordinateNumber(input_latitude_string);
    const longitude = ToCoordinateNumber(input_longitude_string);

    // Center position maps
    const center = { lat: latitude, lng: longitude };

    // Create the map
    map = new google.maps.Map(document.getElementById(divid), { zoom: mapsZoom, center: center, mapId: "map" });

    // Marker
    const marker = { lat: latitude, lng: longitude };

    //place the marker
    nawMarker = new google.maps.marker.AdvancedMarkerElement({
        position: marker,
        map: map
    });

    if (editmode) {
        map.addListener('click', function (e: any) {
            placeMarkerAndPanTo(e.latLng, map);
        });
    }
}

/**
 * update longitude and latitude
 * @param {any} googleApiKey
 */
export function updateLonitudeLatitude(googleApiKey: string, address: string): void {

    // Web request to the google service. This will tranform the address into a longitude and latitude
    const url = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + encodeURIComponent(address) + '&key=' + googleApiKey;

    // place marker in callback
    $.get(url, function (geoCodingResult) {

        //process result;
        if (geoCodingResult.status === 'OK') {

            const lat = geoCodingResult.results[0].geometry.location.lat;
            const lng = geoCodingResult.results[0].geometry.location.lng;

            $("#LatitudeStr").data("kendoTextBox").value(lat.toLocaleString(undefined, { minimumFractionDigits: 6 }));
            $("#LongitudeStr").data("kendoTextBox").value(lng.toLocaleString(undefined, { minimumFractionDigits: 6 }));

            const latlng = new google.maps.LatLng({ lat: lat, lng: lng });

            placeMarkerAndPanTo(latlng, map);
        }
    });

}
